import { __assign as i } from "./index11.js";
var g = (
  /** @class */
  function() {
    function n() {
      this._logs = [];
    }
    return n.prototype.log = function(l, t, e) {
      var s = /* @__PURE__ */ new Date();
      this._logs.push({
        level: l,
        message: t,
        time: s,
        extras: e
      });
    }, Object.defineProperty(n.prototype, "logs", {
      get: function() {
        return this._logs;
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.flush = function() {
      if (this.logs.length > 1) {
        var l = this._logs.reduce(function(t, e) {
          var s, o, a, u = i(i({}, e), { json: JSON.stringify(e.extras, null, " "), extras: e.extras });
          delete u.time;
          var r = (a = (o = e.time) === null || o === void 0 ? void 0 : o.toISOString()) !== null && a !== void 0 ? a : "";
          return t[r] && (r = "".concat(r, "-").concat(Math.random())), i(i({}, t), (s = {}, s[r] = u, s));
        }, {});
        console.table ? console.table(l) : console.log(l);
      } else
        this.logs.forEach(function(t) {
          var e = t.level, s = t.message, o = t.extras;
          e === "info" || e === "debug" ? console.log(s, o ?? "") : console[e](s, o ?? "");
        });
      this._logs = [];
    }, n;
  }()
);
export {
  g as CoreLogger
};
//# sourceMappingURL=index94.js.map
